import React, { useEffect } from "react";
import { Select } from "antd";
import GetProductTypes from "../../functions/reference/getProductType";
import GetMerchants from "../../functions/admin/getMerchants";
import GetSubMerchants from "functions/admin/getSubMerchants";

const { Option } = Select;

const SubMerchantSelect = ({
  onChange,
  value,
  size = "medium",
  merchantId,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    fetchList();
  }, []);
  const fetchList = async () => {
    setLoading(true);
    const response = await GetSubMerchants(merchantId);
    setLoading(false);
    if (response) {
      var data = response.data.map((e) => ({ id: e.id, name: e.name }));
      if (true)
        // add extra select option
        data = [{ id: null, name: "сонго" }, ...data];
      setData(data);
      if (!value) onChange(data[0].id);
    }
  };
  return (
    <Select
      placeholder="Select a merchant"
      onChange={onChange}
      value={value}
      loading={loading}
      size={size}
      style={{ width: "100%" }}
    >
      {data.map((item) => (
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default SubMerchantSelect;
